module.exports = __webpack_public_path__ + "img/logo.18e24279.png";